import { types } from 'mobx-state-tree'

export const Padding = types.model('Padding', {
  top: types.number,
  right: types.number,
  bottom: types.number,
  left: types.number
})
